/*
 * Copyright (c) 2025 Amazon.com
 * This file is licensed under the MIT License.
 * See the LICENSE file in the project root for full license information.
 */
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const CALLS_PATH = '/calls';
export const STREAM_AUDIO_PATH = '/stream';
export const VIRTUAL_PARTICIPANT_PATH = '/virtual-participant';
export const MCP_SERVERS_PATH = '/configuration/mcp-servers';
export const DEFAULT_PATH = CALLS_PATH;
export const REDIRECT_URL_PARAM = 'redirect';
export const MEETINGS_QUERY_PATH = `${CALLS_PATH}/query`;
